module.exports = __webpack_public_path__ + "81c8b1a519883c877a62e1b787736939.pdf";